import React from 'react';
import { AsgardP, Button, Div } from '@app/globalstyles/asgard';
import PropTypes from 'prop-types';
import { PagesNav, TableFooter } from './style';
import Colors from '@app/globalstyles/utils/colors';

function getPageRange(currentPage, pagesCount) {
  const maxVisible = 5;

  if (pagesCount <= maxVisible + 2) {
    const pages = [];
    for (let i = 1; i <= pagesCount; i++) pages.push(i);
    return pages;
  }

  const pages = [1];
  let start = Math.max(2, currentPage - 1);
  let end = Math.min(pagesCount - 1, currentPage + 1);

  if (currentPage <= 3) {
    start = 2;
    end = Math.min(maxVisible, pagesCount - 1);
  } else if (currentPage >= pagesCount - 2) {
    start = Math.max(2, pagesCount - maxVisible + 1);
    end = pagesCount - 1;
  }

  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < pagesCount - 1) pages.push('...');

  pages.push(pagesCount);
  return pages;
}

function Pagination({ itemsCount, pageSize, currentPage, onPageChange }) {
  const pagesCount = Math.ceil(itemsCount / pageSize);
  if (pagesCount <= 1) return null;

  const pages = getPageRange(currentPage, pagesCount);

  return (
    <TableFooter>
      <PagesNav>
        <AsgardP>Page</AsgardP>{' '}
        <AsgardP ml="5px" fw="bold">
          {currentPage}{' '}
        </AsgardP>
        <AsgardP ml="5px">of</AsgardP>{' '}
        <AsgardP ml="5px" fw="900">
          {pagesCount}
        </AsgardP>
      </PagesNav>
      <PagesNav>
        <Div display="flex" mt="15px" mb="15px" style={{ alignItems: 'center' }}>
          <Button
            display="flex"
            ml="5px"
            p="0px 10px"
            bc="transparent"
            br="7px"
            cursor={currentPage === 1 ? 'default' : 'pointer'}
            onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
            style={{ opacity: currentPage === 1 ? 0.4 : 1 }}
          >
            <AsgardP color={Colors.blackish}>&lsaquo;</AsgardP>
          </Button>

          {pages.map((page, index) =>
            page === '...' ? (
              <AsgardP key={`ellipsis-${index}`} ml="5px" color={Colors.blackish}>
                ...
              </AsgardP>
            ) : (
              <Button
                key={page}
                display="flex"
                ml="5px"
                p="0px 15px"
                bc={page === currentPage ? '#F5F5F5' : 'transparent'}
                br="7px"
                cursor="pointer"
                onClick={() => onPageChange(page)}
              >
                <AsgardP
                  fw={page === currentPage ? 'bold' : 'normal'}
                  color={Colors.blackish}
                >
                  {page}
                </AsgardP>
              </Button>
            )
          )}

          <Button
            display="flex"
            ml="5px"
            p="0px 10px"
            bc="transparent"
            br="7px"
            cursor={currentPage === pagesCount ? 'default' : 'pointer'}
            onClick={() => currentPage < pagesCount && onPageChange(currentPage + 1)}
            style={{ opacity: currentPage === pagesCount ? 0.4 : 1 }}
          >
            <AsgardP color={Colors.blackish}>&rsaquo;</AsgardP>
          </Button>
        </Div>
      </PagesNav>
    </TableFooter>
  );
}

Pagination.propTypes = {
  itemsCount: PropTypes.number,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

export default Pagination;
